import CsI18n from "../shared/csI18n";

const ChoiceHelper = {
  // Format list of choices for <Select>
  choices: (choiceList, i18n = true) => {
    return choiceList.map(item => ({
      value: item.key,
      label: i18n ? CsI18n.t(item.label) : item.label
    }));
  },

  // Get all the chosen ones from choice list
  selected: (choiceList) => {
    return choiceList.filter(item => item.selected).map(item => item.key);
  },

  // Get only the first one from the chosen ones
  selectedFirst: (choiceList) => {
    return ChoiceHelper.selected(choiceList).shift();
  },

  toggleAll: (choiceList, value) => {
    return choiceList.map(item => {
      let modifyItem = Object.assign({}, item);
      modifyItem.selected = value;
      return modifyItem;
    });
  },

  onChange: (changedValue, choices) => {
    return choices.map(item => {
      let modifyItem = Object.assign({}, item);
      modifyItem.selected = changedValue.includes(modifyItem.key);
      return modifyItem;
    });
  },
}

export default ChoiceHelper;
